import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectWalletAccount = createSelector(
	(state: IStore) => state.walletAccount,
	(walletAccount) => walletAccount
)
